"use client";

import { useUserRealmId } from "@easybiz/component-shared";
import { STATUSES_KEY_COUNTER } from "@easybiz/utils";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

export default (key) => {
  const realmId = useUserRealmId();
  const [statusDoc, setStatusDoc] = useState(null);

  useEffect(() => {
    setStatusDoc(null);
    if (realmId && key) {
      return onSnapshot(
        doc(getFirestore(), `realms/${realmId}/statuses/${STATUSES_KEY_COUNTER}/keys/${key}`),
        setStatusDoc
      );
    }
  }, [realmId, key]);

  return statusDoc;
};
